import * as React from 'react';
import { FaIcon } from '../generic/icon';

interface ReadTimeProps {
  textToCalc: string;
}

export default function ReadTime ({ textToCalc }: ReadTimeProps) {
  const textEl = React.useRef(document.querySelector(textToCalc));

  if (!textEl.current) {
    return null;
  }

  const characterCount = textEl.current.textContent?.replace(/[^\w ]/g, '').split(/\s+/).length;

  if (!characterCount) {
    return null;
  }

  const readingTime = parseInt((characterCount / 200).toFixed(0), 10);
  const readingStr = readingTime > 0 ? `~ ${readingTime} min` : `${readingTime} min`;

  return <><FaIcon clsName='fa-regular fa-clock' /> {readingStr}</>;
}